import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Menu, X } from 'lucide-react';
import './GolferAuthLayout.css';

// Assets
import darkLogo from '../Assets/Images/Dark_Logo_Transparent.png';

const GolferAuthLayout = ({ children, seoTitle, seoDescription, canonicalPath, hideGetStarted }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="golfer-auth-page">
      <Helmet>
        <title>{seoTitle || 'PrivateIQ'}</title>
        {seoDescription && <meta name="description" content={seoDescription} />}
        {canonicalPath && <link rel="canonical" href={`https://privateiq.golf${canonicalPath}`} />}
        <meta name="theme-color" content="#2c5c4f" />
      </Helmet>

      {/* ===== HEADER ===== */}
      <header className={`ga-header ${scrolled ? 'scrolled' : ''}`}>
        <div className="ga-header-inner">
          {/* Logo */}
          <Link to="/" className="ga-header-logo">
            <img src={darkLogo} alt="PrivateIQ" />
          </Link>

          {/* Desktop Navigation */}
          <nav className="ga-header-nav">
            <Link to="/">Home</Link>
            <Link to="/contact">Contact</Link>
          </nav>

          {/* Auth Buttons (Desktop) */}
          <div className="ga-header-auth">
            <div className="ga-header-divider"></div>
            <Link to="/login" className="ga-header-login">Login</Link>
            {!hideGetStarted && (
              <Link to="/register" className="ga-header-register">Get Started</Link>
            )}
          </div>

          {/* Mobile */}
          <div className="ga-header-mobile">
            {!hideGetStarted && (
              <Link to="/register" className="ga-mobile-register">Get Started</Link>
            )}
            <button
              className="ga-header-mobile-btn"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              aria-label="Toggle menu"
            >
              {mobileMenuOpen ? <X className="ga-w-5 ga-h-5" /> : <Menu className="ga-w-5 ga-h-5" />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="ga-mobile-menu">
            <nav className="ga-mobile-nav">
              <Link to="/" onClick={() => setMobileMenuOpen(false)}>Home</Link>
              <Link to="/contact" onClick={() => setMobileMenuOpen(false)}>Contact</Link>
            </nav>
            <div className="ga-mobile-auth-links">
              <Link to="/login" onClick={() => setMobileMenuOpen(false)}>Login</Link>
              {!hideGetStarted && (
                <Link
                  to="/register"
                  className="ga-mobile-register-btn"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Get Started
                </Link>
              )}
            </div>
          </div>
        )}
      </header>

      {/* ===== MAIN CONTENT ===== */}
      <main className="ga-main">
        <div className="ga-main-bg"></div>
        {children}
      </main>

      {/* ===== FOOTER ===== */}
      <footer className="ga-footer">
        <div className="ga-footer-container">
          <div className="ga-footer-grid">
            <div className="ga-footer-brand">
              <div className="ga-footer-logo">privateIQ</div>
              <p className="ga-footer-tagline">
                The modern source for private golf club intelligence.
              </p>
            </div>
            <div className="ga-footer-links">
              <h4>Platform</h4>
              <ul>
                <li><Link to="/">Home</Link></li>
                <li><Link to="/myclub/register">For Clubs</Link></li>
              </ul>
            </div>
            <div className="ga-footer-links">
              <h4>Company</h4>
              <ul>
                <li><Link to="/contact">Contact</Link></li>
              </ul>
            </div>
            <div className="ga-footer-links">
              <h4>Legal</h4>
              <ul>
                <li><Link to="/termsofservice">Terms of Service</Link></li>
                <li><Link to="/privacypolicy">Privacy Policy</Link></li>
                <li><Link to="/privacy-choices">Privacy Choices</Link></li>
              </ul>
            </div>
          </div>
          <div className="ga-footer-bottom">
            <p>&copy; 2025 Non-Target LLC. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default GolferAuthLayout;
